PJQ.collections.submittals = {};

PJQ.models.submittals = {};

PJQ.views.submittals = {};

PJQ.modules.submittals = {
    routes: [
        {
            route: 'projects/:projectId/submittalsnew',
            name: 'submittalsnew',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "submittalsnew");
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.submittals.routes);
